module.exports = __webpack_public_path__ + "img/Picture6.3a7897d0.jpg";